/**
 * @generated SignedSource<<21fa1769b9b61c08f056bce947877848>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type reportCategory_reportsOverviewPage$data = {
  readonly name: string;
  readonly reports: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "JiraReport";
        readonly name: string;
        readonly " $fragmentSpreads": FragmentRefs<"reportCard_reportsOverviewPage">;
      };
    } | null | undefined>;
  };
  readonly " $fragmentType": "reportCategory_reportsOverviewPage";
};
export type reportCategory_reportsOverviewPage$key = {
  readonly " $data"?: reportCategory_reportsOverviewPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"reportCategory_reportsOverviewPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "name"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "reportCategory_reportsOverviewPage",
  "selections": [
    {
      "kind": "RequiredField",
      "field": (v0/*: any*/),
      "action": "THROW",
      "path": "name"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "JiraReportConnection",
        "kind": "LinkedField",
        "name": "reports",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "concreteType": "JiraReportConnectionEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "RequiredField",
                  "field": {
                    "concreteType": "JiraReport",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      {
                        "kind": "RequiredField",
                        "field": (v0/*: any*/),
                        "action": "THROW",
                        "path": "reports.edges.node.name"
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "reportCard_reportsOverviewPage"
                      }
                    ]
                  },
                  "action": "THROW",
                  "path": "reports.edges.node"
                }
              ]
            },
            "action": "THROW",
            "path": "reports.edges"
          }
        ]
      },
      "action": "THROW",
      "path": "reports"
    }
  ],
  "type": "JiraReportCategoryNode"
};
})();

(node as any).hash = "8f7729322daa1ba2c2a98fc5715fd793";

export default node;
